import React from 'react'
import styled, { keyframes } from 'react-emotion'

const Container = styled.div`
  display: inline-block;
  position: relative;
  width: 64px;
  height: 12px;
`

const animationOne = keyframes`
    0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
`
const animationTwo = keyframes`
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
`
const animationThree = keyframes`
    0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
`

const Dot = styled.div`
  position: absolute;
  top: 2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);

  &:nth-child(1) {
    left: 6px;
    animation: ${animationOne} 0.6s infinite;
  }
  &:nth-child(2) {
    left: 6px;
    animation: ${animationTwo} 0.6s infinite;
  }
  &:nth-child(3) {
    left: 26px;
    animation: ${animationTwo} 0.6s infinite;
  }
  &:nth-child(4) {
    left: 45px;
    animation: ${animationThree} 0.6s infinite;
  }
`

export const Loader = () => (
  <Container>
    <Dot className="loading-dot" />
    <Dot className="loading-dot" />
    <Dot className="loading-dot" />
    <Dot className="loading-dot" />
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/Loader.js